import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import founderImg from '../assets/newHeader/founder-image.png';
import VP2 from '../assets/public-site/Alan1.png';
import EdcuationSector from '../assets/public-site/Brett1.png';
import Healthcare from '../assets/public-site/Edwin1.png';
import FSD2 from '../assets/public-site/Geralad1.png';
import FSD1 from '../assets/public-site/Jenn1.png';
import HeadofEnterprise from '../assets/public-site/Josh1.png';
import { ReactComponent as Linkedin } from '../assets/public-site/LinkedIn_icon.svg 1.svg';
import VP1 from '../assets/public-site/Marry1.png';
import PublicSector from '../assets/public-site/steven.png';
import introImg from '../assets/public-site/TeamIntro.jpg';
import { ExportedIcon } from '../components/icons/icons';
import { NewFooter } from '../components/Layout/NewFooter';
import { NewNavbar } from '../components/Layout/NewHeader';

import { ConnectForm } from './ConnectUseForm';

export const TeamPage: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      {/* Header */}
      <NewNavbar />

      {/* Hero Banner Section */}
      {/* hero section */}
      <section
        className="
    relative w-full h-screen bg-cover bg-center bg-no-repeat 
    before:absolute before:inset-0 before:z-10 
    lg:before:hidden
    before:bg-gradient-to-r before:from-black before:to-transparent
  "
        style={{
          backgroundImage: `
      linear-gradient(180deg, rgba(0, 0, 0, 0) 47.64%, #000000 100%),
      url(${introImg})
    `,
        }}
      >
        <div className="relative z-20 flex items-end justify-center h-full container mx-auto px-6 pb-10 text-white text-center">
          <div className="w-full space-y-6">
            <h1 className="text-4xl text-[#FFFFFF] sm:text-5xl">
              Meet the Team <span className="text-[#FFC90D] font-bold">Behind Vero</span>
            </h1>
            <p className="mt-2 text-[#FFFFFF] text-xl sm:text-2xl !leading-normal">
              We’re not just building a product. We’re building infrastructure to surface overlooked
              talent, close equity gaps, and transform the future of work.
            </p>

            {/* <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-primary !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule a strategy session <ExportedIcon />
            </a> */}
          </div>
        </div>
      </section>

      {/* Founder Note Section */}
      <section className="flex items-center justify-center bg-white py-28">
        <div className="container">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            {/* Text Section */}
            <div className="text-center lg:text-left">
              <p className="text-2xl mb-4">Founder & CEO</p>
              <h3 className="text-4xl md:text-5xl lg:text-6xl font-light !leading-snug mb-6">
                Chrissybil <span className="text-[#4A5FF7] font-bold">Boulin</span>
              </h3>
              <p className="text-xl leading-loose mb-4">
                Chrissybil is a second-time founder, Forbes 30 Under 30 honoree, and
                Cambridge-trained economist. She built Vero after seeing too many capable people get
                shut out of opportunity—especially those without perfect resumes or “traditional”
                signals of success. Her journey began in Haiti, where one moment of injustice etched
                itself into her memory: a barefoot child running after her father’s car. “He’s too
                poor to afford a childhood,” her father said. That heartbreak became a lifelong
                mission.
              </p>
              <p className="text-xl leading-loose">
                While at Emory University, Chrissybil launched her first nonprofit. She later scaled
                Jumpstart Tutoring from $500 into a regionally recognized education company that
                helped thousands of students save millions on college tuition. Now at Vero, she’s
                leading a mission-first team that helps employers predict who will succeed, stay,
                and grow—before day one. Under her leadership, Vero has served 35,000+ users, earned
                trust across major employers and workforce boards, and is reshaping how we define
                potential in the modern workforce.
              </p>
            </div>
            {/* Image */}
            <div className="flex-shrink-0">
              <img src={founderImg} alt="Chrissybil Boulin" className="rounded-full" />
            </div>
          </div>
        </div>
      </section>
      {/* Head of Enterprises sale Note Section */}
      <section className="flex items-center justify-center bg-[#E6E8FE] py-28">
        <div className="container">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            {/* Image */}
            <div className="flex-shrink-0">
              <img
                src={HeadofEnterprise}
                alt="Josh McBride"
                className="rounded-full bg-[#e6e1db]"
              />
            </div>
            {/* Text Section */}
            <div className="text-center lg:text-left">
              <p className="text-2xl mb-4">Head of Enterprise Sales</p>
              <h3 className="text-4xl md:text-5xl lg:text-6xl font-light !leading-snug mb-6">
                Josh <span className="text-[#4A5FF7] font-bold">McBride</span>
              </h3>
              <p className="text-xl leading-loose">
                Josh is a two-time exited founder who’s closed over $300M in HR tech and SaaS sales.
                He leads Vero’s employer partnerships and sales strategy—transforming enterprise
                hiring challenges into predictable outcomes. With deep roots in high-velocity GTM,
                Josh helps our partners move fast without losing sight of what matters: building
                resilient teams.
              </p>
              <a
                href="https://www.linkedin.com/in/joshmcbride1/"
                className="btn btn-secondary mt-5 !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin /> Linkedin <ExportedIcon />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Public sector Note Section */}
      <section className="flex items-center justify-center bg-white py-28">
        <div className="container">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            {/* Text Section */}
            <div className="text-center lg:text-left">
              <p className="text-2xl mb-4">Public Sector & Workforce Partnerships</p>
              <h3 className="text-4xl md:text-5xl lg:text-6xl font-light !leading-snug mb-6">
                Steven <span className="text-[#4A5FF7] font-bold">Iglesias</span>
              </h3>
              <p className="text-xl leading-loose">
                Steven builds bridges between public and private systems to unlock opportunity at
                scale. A respected workforce leader, he’s helped shape national efforts to connect
                schools, employers, and community orgs through AI, mobility strategy, and CTE
                alignment. His coalition-building work has earned interest from senior government
                leaders and national mobility councils.
              </p>
              <a
                href="https://www.linkedin.com/in/steven-iglesias-244b9199/"
                className="btn btn-secondary mt-5 !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin /> Linkedin <ExportedIcon />
              </a>
            </div>
            {/* Image */}
            <div className="flex-shrink-0">
              <img src={PublicSector} alt="Steven Iglesias" className="rounded-full " />
            </div>
          </div>
        </div>
      </section>

      {/* Education Note Section */}
      <section className="flex items-center justify-center bg-[#E6E8FE] py-28">
        <div className="container">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            {/* Image */}
            <div className="flex-shrink-0 ">
              <img src={EdcuationSector} alt="Brett Roer" className=" rounded-full " />
            </div>
            {/* Text Section */}
            <div className="text-center lg:text-left">
              <p className="text-2xl mb-4">Education & Nonprofit Strategy</p>
              <h3 className="text-4xl md:text-5xl lg:text-6xl font-light !leading-snug mb-6">
                Brett <span className="text-[#4A5FF7] font-bold">Roer</span>
              </h3>
              <p className="text-xl leading-loose">
                Brett brings 20+ years as a nationally recognized school leader and equity
                strategist. Formerly a principal in NYC, he now helps Vero align with districts,
                reentry programs, and nonprofit partners. Brett is known for turning theory into
                action—designing systems that serve justice-involved youth, elevate future-ready
                educators, and unlock real-world outcomes.
              </p>
              <a
                href="https://www.linkedin.com/in/brett-roer/"
                className="btn btn-secondary mt-5 !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin /> Linkedin <ExportedIcon />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Healthcare sector Note Section */}
      <section className="flex items-center justify-center bg-white py-28">
        <div className="container">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            {/* Text Section */}
            <div className="text-center lg:text-left">
              <p className="text-2xl mb-4">Healthcare & Employer Partnerships</p>
              <h3 className="text-4xl md:text-5xl lg:text-6xl font-light !leading-snug mb-6">
                Edwin <span className="text-[#4A5FF7] font-bold">Rivera</span>
              </h3>
              <p className="text-xl leading-loose">
                Edwin shapes go-to-market strategy for high-churn sectors like healthcare and
                logistics. With decades of experience across workforce development, XR training, and
                staffing systems, he brings a practitioner’s lens to every pilot. Edwin helps
                operational leaders configure Vero to mirror their reality—ensuring success on the
                floor, not just on paper.
              </p>
              <a
                href="https://www.linkedin.com/in/edwinrivera/"
                className="btn btn-secondary mt-5 !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin /> Linkedin <ExportedIcon />
              </a>
            </div>
            {/* Image */}
            <div className="flex-shrink-0">
              <img src={Healthcare} alt="Edwin Rivera" className="rounded-full " />
            </div>
          </div>
        </div>
      </section>
      {/* VP1 Note Section */}
      <section className="flex items-center justify-center bg-[#E6E8FE] py-28">
        <div className="container">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            {/* Image */}
            <div className="flex-shrink-0">
              <img src={VP1} alt="Mary Bryan" className="rounded-full " />
            </div>
            {/* Text Section */}
            <div className="text-center lg:text-left">
              <p className="text-2xl mb-4">VP of HR, Office Depot</p>
              <h3 className="text-4xl md:text-5xl lg:text-6xl font-light !leading-snug mb-6">
                Mary <span className="text-[#4A5FF7] font-bold">Bryan (Advisor)</span>
              </h3>
              <p className="text-xl leading-loose">
                Mary is a corporate HR leader with deep expertise in internal mobility and workforce
                transformation. She advises Vero on national hiring strategies, talent retention,
                and high-scale retail operations.
              </p>
              <a
                href="https://www.linkedin.com/in/mebster1/"
                className="btn btn-secondary mt-5 !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin /> Linkedin <ExportedIcon />
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* FSD1 sector Note Section */}
      <section className="flex items-center justify-center bg-white py-28">
        <div className="container">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            {/* Text Section */}
            <div className="text-center lg:text-left">
              <p className="text-2xl mb-4">VP of Growth, International Franchise Association</p>
              <h3 className="text-4xl md:text-5xl lg:text-6xl font-light !leading-snug mb-6">
                Alan <span className="text-[#4A5FF7] font-bold">Catlett (Advisor)</span>
              </h3>
              <p className="text-xl leading-loose">
                Alan is a nationally recognized product and operations leader with a track record of
                scaling platforms across workforce, education, and franchise sectors. As SVP at the
                International Franchise Association, he advises Vero on enterprise strategy,
                infrastructure, and systems that expand economic opportunity at scale.
              </p>
              <a
                href="https://www.linkedin.com/in/accatlett/"
                className="btn btn-secondary mt-5 !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin /> Linkedin <ExportedIcon />
              </a>
            </div>
            {/* Image */}
            <div className="flex-shrink-0">
              <img src={VP2} alt="Alan Catlett" className="rounded-full " />
            </div>
          </div>
        </div>
      </section>
      <section className="flex items-center justify-center bg-[#E6E8FE] py-28">
        <div className="container">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            {/* Image */}
            <div className="flex-shrink-0">
              <img src={FSD1} alt="Jenn Schiffner" className="rounded-full " />
            </div>
            {/* Text Section */}
            <div className="text-center lg:text-left">
              <p className="text-2xl mb-4">Former Senior Director, People Partner at Visa</p>
              <h3 className="text-4xl md:text-5xl lg:text-6xl font-light !leading-snug mb-6">
                Jenn <span className="text-[#4A5FF7] font-bold">Schiffner (Advisor)</span>
              </h3>
              <p className="text-xl leading-loose">
                Jenn brings strategic HR and compliance experience across financial services and
                global tech. She ensures Vero’s growth is grounded in the needs of enterprise HR
                teams—especially when it comes to data integrity, legal risk, and people ops
                alignment.
              </p>
              <a
                href="https://www.linkedin.com/in/jennschiffner/"
                className="btn btn-secondary mt-5 !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin /> Linkedin <ExportedIcon />
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Former Superintendent sector Note Section */}
      <section className="flex items-center justify-center bg-white py-28 mb-8">
        <div className="container">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            {/* Text Section */}
            <div className="text-center lg:text-left">
              <p className="text-2xl mb-4">Former Superintendent</p>
              <h3 className="text-4xl md:text-5xl lg:text-6xl font-light !leading-snug mb-6">
                Gerald <span className="text-[#4A5FF7] font-bold">Hill (Advisor)</span>
              </h3>
              <p className="text-xl leading-loose">
                Gerald is a veteran district leader who ensures Vero’s school partnerships are
                rooted in what matters to educators, employers, and families. He supports Vero’s
                long-term vision around equity, workforce readiness, and public-private alignment.
              </p>
              <a
                href="https://www.linkedin.com/in/gerald-hill-82143314/"
                className="btn btn-secondary mt-5 !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin /> Linkedin <ExportedIcon />
              </a>
            </div>
            {/* Image */}
            <div className="flex-shrink-0">
              <img src={FSD2} alt="Gerald Hill" className="rounded-full " />
            </div>
          </div>
        </div>
      </section>

      {/* contact us section */}
      <ConnectForm
        header="Stop guessing. Start scaling what works."
        text="When you place the right people in the right roles, you don’t just fill jobs—you power throughput, reduce risk, and strengthen your floor. Vero gives you the insight to do it at scale."
        buttonText="Book time here"
        actionButtonText="Book your 15-minute demo now"
      />
      <NewFooter />
    </>
  );
};
